import FoldersTable from "@/components/foldersTable/page";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { getFolders } from "@/redux/clients/clients.action";
import { useAppDispatch } from "@/redux/hooks";
import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { clientSelector } from "@/redux/clients/clients.selector";
import { TableSkeleton } from "@/components/ui/loading";

export const FoldersPage = () => {
  const dispatch = useAppDispatch();
  const { clienteId, clienteNombre } = useLocation().state;
  const { loading } = useSelector(clientSelector).ui;

  useEffect(() => {
    dispatch(getFolders(clienteId));
  }, [dispatch, clienteId]);

  return (
    <Box className="flex flex-col p-4 h-full ">
      <Card className="w-full h-full gap-0">
        <CardHeader className="flex flex-col gap-0">
          <CardTitle>
            <Typography fontFamily={"Inter"} fontSize={"18px"} fontWeight={500}>
              Carpetas
            </Typography>
          </CardTitle>
          <CardDescription>
            <Typography fontFamily={"Inter"} fontSize={"14px"} fontWeight={400}>
              Gestiona las carpetas de {clienteNombre}.
            </Typography>
          </CardDescription>
          <Separator className="w-full mt-4 mb-2" />
        </CardHeader>
        <CardContent>
          {loading ? <TableSkeleton rows={8} columns={6} /> : <FoldersTable />}
        </CardContent>
      </Card>
    </Box>
  );
};
